import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Hand } from "lucide-react";

export const GripGuide = ({ open, onOpenChange }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-[440px]" data-testid="grip-guide-dialog">
      <DialogHeader>
        <DialogTitle style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Hand size={18} /> Quick grip guide
        </DialogTitle>
        <DialogDescription>
          Grip = distance from your ring-finger tip to the middle crease of your palm.
        </DialogDescription>
      </DialogHeader>
      <div style={{ display: "grid", gap: 10, paddingTop: 6 }}>
        <div className="cd-option" style={{ cursor: "default", minHeight: 60 }}>
          <div className="cd-icon-wrap"><Hand size={18} /></div>
          <div>
            <div style={{ fontWeight: 600 }}>Small · 4 – 4 1/8 in</div>
            <div className="cd-micro">More wrist snap, easier spin</div>
          </div>
        </div>
        <div className="cd-option" style={{ cursor: "default", minHeight: 60 }}>
          <div className="cd-icon-wrap"><Hand size={18} /></div>
          <div>
            <div style={{ fontWeight: 600 }}>Medium · 4 1/4 in</div>
            <div className="cd-micro">Most popular, balanced feel</div>
          </div>
        </div>
        <div className="cd-option" style={{ cursor: "default", minHeight: 60 }}>
          <div className="cd-icon-wrap"><Hand size={18} /></div>
          <div>
            <div style={{ fontWeight: 600 }}>Large · 4 3/8 – 4 1/2 in</div>
            <div className="cd-micro">Extra stability, less spin</div>
          </div>
        </div>
      </div>
      <div className="cd-micro" style={{ paddingTop: 8 }}>
        When in doubt, size down — you can build up with overgrip.
      </div>
    </DialogContent>
  </Dialog>
);
